module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXBAMAAAD9xqKtAAAAMFBMVEVHcEz///////////////////////////////////////////////////////////9EPuwCAAAAD3RSTlMAw/Oi3hcqTg13tGGEjjv6HO3eAAAAx0lEQVQY02NgAIKXxscDGMCAY9L///8/J4DZRf+tU2v8/4KY3P9nMHAwsPsvALL3qzEwyDcwMP9iYGD9D9QmD8ITGBi/M0DYTD8Y8gWgbO4/DPcLoGyGTwz+DDC2PMMXMBtE3Gf4CGbfABLzIeJPPm1gYDjPoA92x/wvBQz2DOvBjmK1/wsUrTcAS/CtYfsFsg4CGP8xsH+EsucDHWoPUcT+qQEo9xGs+/w3EGn/+QUD26QvYBFu//9K//8fgOjiu6jkvANIAwCEbj3y0q1YkgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/fundingnew_/icon-time.png
// module id = +iJB
// module chunks = 1